module.exports = __webpack_public_path__ + "assets/5d5219b88ac45720336e6079ed93a27e.png";